import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLang } from '../context/LangContext';
import { API_URL } from '../config';

const API = API_URL;

const Hero = () => {
  const { t } = useLang();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/products/stats/public`)
      .then(r => setStats(r.data.data))
      .catch(() => {});
  }, []);

  const heroImage = stats?.heroProduct?.image
    || 'https://images.unsplash.com/photo-1695048133142-1a20484d2569?w=300&h=600&fit=crop';
  const heroAlt = stats?.heroProduct?.name || 'Featured product';

  return (
    <section className="hero-v2">
      <div className="hero-v2__bg">
        <div className="hero-v2__gradient-blob hero-v2__gradient-blob--1" />
        <div className="hero-v2__gradient-blob hero-v2__gradient-blob--2" />
        <div className="hero-v2__gradient-blob hero-v2__gradient-blob--3" />
        <div className="hero-v2__grid" />
      </div>

      <div className="hero-v2__inner">
        <div className="hero-v2__content">
          <div className="hero-v2__eyebrow">
            <span className="hero-v2__dot" />
            {t('hero_badge')}
          </div>

          <h1 className="hero-v2__title">
            <span className="hero-v2__title-line hero-v2__title-line--1">Matrix</span>
            <span className="hero-v2__title-line hero-v2__title-line--2">Electronic</span>
            <span className="hero-v2__title-line hero-v2__title-line--3">Devices</span>
          </h1>

          <p className="hero-v2__by">
            BY <strong>Maher</strong>
          </p>

          <p className="hero-v2__subtitle">{t('hero_subtitle')}</p>

          <div className="hero-v2__cta">
            <a href="#products" className="hero-v2__btn hero-v2__btn--primary">
              {t('hero_cta_buy')}
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </a>
            <a href="#products" className="hero-v2__btn hero-v2__btn--ghost">{t('hero_cta_view')}</a>
          </div>

          <div className="hero-v2__stats">
            <div className="hero-v2__stat">
              <strong>{stats ? stats.total : '—'}</strong>
              <span>{t('hero_stat_products')}</span>
            </div>
            <div className="hero-v2__stat-sep" />
            <div className="hero-v2__stat">
              <strong>{stats ? `${stats.totalStock}+` : '—'}</strong>
              <span>{t('hero_stat_clients')}</span>
            </div>
            <div className="hero-v2__stat-sep" />
            <div className="hero-v2__stat">
              <strong>{stats ? `${stats.avgRating}★` : '—'}</strong>
              <span>{t('hero_stat_rating')}</span>
            </div>
          </div>
        </div>

        <div className="hero-v2__visual">
          <div className="hero-v2__phone-wrap">
            <div className="hero-v2__phone-glow" />
            <div className="hero-v2__phone-ring hero-v2__phone-ring--outer" />
            <div className="hero-v2__phone-ring hero-v2__phone-ring--inner" />
            <img
              src={heroImage}
              alt={heroAlt}
              className="hero-v2__phone-img"
            />

            <div className="hero-v2__badge-float hero-v2__badge-float--top">
              <div className="hero-v2__badge-icon">📦</div>
              <div className="hero-v2__badge-text">
                <strong>{t('hero_shipping_label')}</strong>
                <small>{t('hero_shipping_sub')}</small>
              </div>
            </div>

            <div className="hero-v2__badge-float hero-v2__badge-float--bottom">
              <div className="hero-v2__badge-icon">⚡</div>
              <div className="hero-v2__badge-text">
                <strong>{t('hero_flash_label')}</strong>
                <small>{t('hero_flash_sub')}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hero-v2__scroll-hint">
        <div className="hero-v2__scroll-line" />
        <span>Scroll</span>
      </div>
    </section>
  );
};

export default Hero;
